import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IResumeCampaignPayload {
    campaignId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const resumeCampaign = createSlice({
    name: 'campaigns/resume-campaign',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IResumeCampaignPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const resumeCampaignActions = resumeCampaign.actions
export default resumeCampaign.reducer
